





























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter } from "vuex-class";

import WelcomeMessage from "@/components/assistant/WelcomeMessage.vue";
import Message from "@/components/assistant/Message.vue";
import RelatedQuestions from "@/components/assistant/RelatedQuestions.vue";
import { AssistantState } from "@/store/assistant/types";

import MarkdownIt from "markdown-it";

import { isNullOrUndefined } from "util";

const markdown = new MarkdownIt({
    html: false,
    linkify: true,
    breaks: true,
});

@Component({
    components: {
        WelcomeMessage,
        Message,
        RelatedQuestions,
    },
})
export default class Conversation extends Vue {
    @Prop({ default: () => [] }) private subjects!: any[];
    @Prop({ default: () => [] }) private messages!: any[];
    @Prop({
        default: () => ({
            content: "",
            role: "",
            subject: null,
            images: [],
            status: "",
            date: null,
        }),
    })
    private progressiveMessage!: any;

    @State("assistant") assistant!: AssistantState;

    @Getter("assistant/assistantName") assistantName!: string;
    @Getter("auth/firstName") firstName!: string;

    messages_length = 0;

    /**
     * Render user messages as inline Markdown so the message remains on the
     * same line as the "Hey Herbie," prefix.
     *
     * Render assistant messages as block Markdown so headings, paragraphs,
     * lists, code blocks and other block-level elements display correctly.
     */
    renderMessage(content: string, role: string): string {
        if (!content) {
            return "";
        }

        const trimmedContent = content.trim();

        if (role == "user") {
            return markdown.renderInline(trimmedContent);
        }

        return markdown.render(trimmedContent);
    }

    @Watch("messages", { deep: false })
    onMessagesChanged(val: any, oldVal: any) {
        Vue.nextTick(() => {
            if (this.assistant.playAudioResponses) {
                if (this.messages_length == val.length - 1) {
                    if (val[val.length - 1].role == "assistant") {
                        const messageReference = this.$refs[
                            "message-" + (val.length - 1)
                        ] as any;

                        const msg = Array.isArray(messageReference)
                            ? messageReference[0]
                            : messageReference;

                        if (msg) {
                            msg.playAudio();
                        }
                    }
                }
            }

            this.messages_length = val.length;
        });
    }

    subjectLabel(subject: string): string {
        if (isNullOrUndefined(subject)) {
            return "";
        }

        const matchingSubject = this.subjects.find(
            (item: any) => item.id === subject,
        );

        return matchingSubject ? matchingSubject.label : "";
    }
}
